import { render } from "./TecWorldTable.vue?vue&type=template&id=04580d5c"
import script from "./TecWorldTable.vue?vue&type=script&lang=js"
export * from "./TecWorldTable.vue?vue&type=script&lang=js"

import "./TecWorldTable.vue?vue&type=style&index=0&id=04580d5c&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__